// Welke straat een opmerking hoort, en de opmerking zelf, voor een
// wervingsactie ('gesloopt, overgeslagen', 'geen woningen').
//
// Nodig omdat een straat in de lijst per buurt staat, maar een straat over
// twee buurten kan lopen: de opmerking hoort bij de straat, niet bij de buurt.
// Daarom woonplaats + straatnaam, zonder buurtcode. Opslag:
// `Wervingsacties.StraatOpmerkingen[<sleutel>] = { Tekst, Door, Op }`.
//
// Een straatnaam kan een punt bevatten ('St. Janstraat'). Schrijf dus nooit met
// een dotted path ('StraatOpmerkingen.<sleutel>'), dat splitst op die punt;
// gebruik een FieldPath (Detail.jsx).
//
// AI-CONTEXT: See docs/features/wervingsacties-registratie.md (Uitbreiding 2026-10 (2))

/**
 * @param {{ Woonplaats?: string, Straatnaam?: string } | undefined} adres - Adres of registratierij
 * @returns {string} De sleutel, of '' als er geen straatnaam is
 */
const straatKey = (adres) => {
    const straat = (adres?.Straatnaam || '').trim()
    if (!straat) return ''
    return `${(adres?.Woonplaats || '').trim()}|${straat}`
}

/**
 * @param {{ StraatOpmerkingen?: object } | null | undefined} actie - Het Wervingsacties-document
 * @param {string} key - Uit straatKey
 * @returns {string} De tekst, of '' als er geen opmerking is
 */
const straatOpmerking = (actie, key) => {
    const tekst = actie?.StraatOpmerkingen?.[key]?.Tekst
    return typeof tekst === 'string' ? tekst.trim() : ''
}

export { straatKey, straatOpmerking }
